import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Endereco } from './../../modelos/endereco';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-cadastro-endereco',
  templateUrl: './cadastro-endereco.component.html',
  styleUrls: ['./cadastro-endereco.component.css']
})
export class CadastroEnderecoComponent implements OnInit {

  @Output() enderecoEvent: EventEmitter<Endereco>;

  public endereco: Endereco;

  constructor(private modalService: NgbModal) {
    this.enderecoEvent = new EventEmitter<Endereco>();
  }

  cadastrar(content) {

    this.endereco = new Endereco();
	const ngbModalOptions: NgbModalOptions = {
		backdrop: 'static',
		keyboard: false
	};

    this.modalService.open(content, ngbModalOptions).result.then((result) => {
      this.enderecoEvent.emit(this.endereco);
    }, (reason) => {
    });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/cadastro-endereco/cadastro-endereco.component.ts